import React from 'react';
import { motion } from 'framer-motion';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { packagePlanMap } from '../data/packagePlans';
import '../csscomponent/PackageFlow.css';
import { saveCartItem } from '../lib/sqlAuth';
import { useAuth } from '../lib/authSession';

function PackageDetails() {
  const { packageId } = useParams();
  const navigate = useNavigate();
  const plan = packagePlanMap[packageId];
  const { isAuthenticated } = useAuth();

  if (!plan) {
    return <Navigate to="/services" replace />;
  }

  const handleAddToCart = async () => {
    try {
      await saveCartItem({
        packageId: plan.id,
        packageName: plan.name,
        priceInr: plan.price,
        quantity: 1,
      });
      if (!isAuthenticated) {
        sessionStorage.setItem('pendingCheckoutPath', '/dashboard/cart');
        navigate('/login');
        return;
      }
      navigate('/dashboard/cart');
    } catch (_) {
      navigate('/dashboard/cart');
    }
  };

  return (
    <section className="package-flow-page">
      <motion.div
        className="flow-hero"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <p>Website Development Package</p>
        <h1>{plan.name} Package Details</h1>
        <span>
          Review complete scope, timeline, and billing information before moving to payment.
        </span>
      </motion.div>

      <div className="flow-grid">
        <motion.article className="flow-card" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h3>Included Features</h3>
          <ul>
            {plan.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </motion.article>

        <motion.article className="flow-card" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}>
          <h3>Engagement Details</h3>
          <ul>
            {plan.details.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </ul>
          <p className="flow-meta"><strong>Estimated Timeline:</strong> {plan.timeline}</p>
          <p className="flow-meta"><strong>Price:</strong> INR {plan.price.toLocaleString()}</p>
          <p className="flow-meta"><strong>Note:</strong> {plan.billingNote}</p>
        </motion.article>
      </div>

      <div className="flow-actions">
        <Link to="/services" className="flow-btn ghost">Back to Services</Link>
        <button type="button" className="flow-btn ghost" onClick={handleAddToCart}>Add to Cart</button>
        <Link to={`/payment/${plan.id}`} className="flow-btn primary">Continue to Payment</Link>
      </div>
    </section>
  );
}

export default PackageDetails;
